module.exports = __webpack_public_path__ + "static/media/18ECA16.a8e55f4c.jpg";